import AppEditorMixin from "@/protected/mixins/AppEditorMixin";
import StatusesForm from "./StatusesForm";

export default {
  mixins: [AppEditorMixin],

  computed: {
    tabs() {
      return [
        {
          component: this.ProductForm,
          title: () => this.$t("product.tabs.main"),
          icon: "parking"
        },
        {
          component: StatusesForm,
          title: () => this.$t("product.tabs.statuses"),
          icon: "project-diagram"
        }
      ];
    }
  }
};
